module.exports = __webpack_public_path__ + "img/RejectRed.25dfe760.svg";